import styled from '@emotion/styled'
import { mq } from '../../../helpers'
import { gsColors } from '../../../styles/Variables'

export const EventsWrapper = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;

  .hero-component {

    .hero-container-inner {
      ${mq('max', '768px')} {
        height: unset !important;
        height: auto !important;
      }
    }

    .web-header-text {
      ${mq('max', '768px')} {
        display: none;
      }
    }

    .content {
      width: 100%;

      .inner {
        width: 100%;
      }

      button {
        ${mq('max', '768px')} {
          font-size: 16px;
        }
      }

      p {

        ${mq('max', '940px')} {
          font-size: 20px;  
          margin-bottom: 24px;
        }
      }

      h1 {
        ${mq('max', '940px')} {
          font-size: 46px;
        }

        ${mq('max', '821px')} {
          font-size: 42px;
        }
      }
    }
  
    .mobile-header-text {
      display: none;
  
      ${mq('max', '768px')} {
        display: block;
        width: 100% !important;
      }
    }

    .image-placeholder {
      ${mq('max', '768px')} {
        height: 500px !important;
      }
    }
  }

  .dazzling-header {
    display: flex;
    padding: 90px 0 39px 82px;
    width: 100%;
    max-width: 1600px;

    ${mq('max', '768px')} {
      padding: 66px 16px 22px;
    }
  }

`

export const WhyGlamsquadWrapper = styled.section`
  box-sizing: border-box;
  width: 100%;
  max-width: 1600px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 88px;

  ${mq('max', '768px')} {
    padding: 44px 16px;
  }

  .list {
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding-left: 200px;

    ${mq('max', '1024px')} {
      padding-left: 100px;
    }

    ${mq('max', '1024px')} {
      padding-left: 50px;
    }

    ${mq('max', '768px')} {
      padding-left: 0;
    }

    .list-item {
      display: flex;
      flex-direction: row;
      align-items: center;

      .check-box {
        height: 40px;
        width: 40px;
        aspect-ratio: 1/1;
        background-color: ${gsColors.sunsetOrange};
        display: flex;
        justify-content: center;
        align-items: center;

        ${mq('max', '768px')} {
          height: 30px;
          width: 30px;

          img {
            height: 30px;
            width: 30px;
          }
        }
      }

      p {
        ${mq('max', '768px')} {
          margin-left: 40px !important;
        }
      }
    }
  }

  button {

    ${mq('max', '768px')} {
      font-size: 16px;
    }
  }
`

export const ReviewsWrapper = styled.section`
  box-sizing: border-box;
  width: 100%;
  max-width: 1600px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
  background-color: ${gsColors.cobalt};

  ${mq('max', '768px')} {
    padding: 60px 16px;
  }

  .swiper-container-container {
    width: 610px;

    ${mq('max', '768px')} {
      width: 100%;
    }

    .swiper-container {
      position: relative;
      padding-bottom: 40px;
      display: flex;
      justify-content: center;
      align-items: center;

      .custom-next-button {
        background-image: url('/images/arrow-right.png');
        background-color: transparent;
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center;
        border: none;
        height: 32px;
        width: 32px;
        position: absolute;
        bottom: 0;
        right: 40%;
        z-index: 999;
        cursor: pointer;
      }
      
      .custom-prev-button {
        background-image: url('/images/arrow-left.png');
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center;
        background-color: transparent;
        border: none;
        height: 32px;
        width: 32px;
        position: absolute;
        bottom: 0;
        left: 40%;
        z-index: 999;
        cursor: pointer;
      }
    }


    .rating {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      ${mq('max', '768px')} {
        max-width: 90%;
        margin: 0 auto;
      }
  
      .star-container {
        display: flex;
        flex-direction: row;
        gap: 3px;
        margin-bottom: 12px;
      }
    }
  }
`

export const BookEventWrapper = styled.section`
  width: 100%;
  padding: 80px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1600px;
  gap: 18px;

  ${mq('max', '768px')} {
    padding: 40px 0 20px;
  }

  button {
    margin-top: 50px;

    ${mq('max', '768px')} {
      margin-top: 25px;
      font-size: 16px;
    }
  }
`

export const LocationsWrapper = styled.section`
  width: 100%;
  padding: 72px 88px 0;
  max-width: 1600px;

  ${mq('max', '768px')} {
    padding: 50px 16px 0;
  }

  .location-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;

    p {
      ${mq('max', '768px')} {
        font-size: 18px;
      }
    }

    h3 {
      ${mq('max', '768px')} {
        font-size: 14px;
      }
    }

    .divider {
      margin: 0 20px;
      color: rgb(241, 205, 199);

      ${mq('max', '768px')} {
        margin: 0 10px;
      }
    }
  }
`
